import React from 'react';
import DF from 'DisplayFramework';
import { Tabs } from 'antd';
import GetLabel from 'DisplayFramework/components/GetLabel';
import { Line } from '@ant-design/plots';
import { isNil } from 'lodash';
import { toCurrency, } from 'utils/utils';
import DataGrid, { DataGridColDef } from 'components/DataGrid/DataGrid';
import { AssetFutureValueResponse, AssetFutureValueScheduleResponse } from 'services/assets';

export type AssetFVMergedScheduleTableProps = {
  allContext: AssetFutureValueResponse[];
  currcode: string;
};
const { TabPane } = Tabs;

const AssetFVMergedScheduleTable = (props: AssetFVMergedScheduleTableProps) => {
  const { allContext, currcode } = props;

  const firstContext=allContext[0];
  const firstContextSchedule=firstContext?.fvSchedule;

  const data = firstContextSchedule?.map((elem:AssetFutureValueScheduleResponse) => {
     

      const fvcontext: any = allContext.filter(
        (ele: any) => ele.contextid !== firstContext.contextid).map((ctx:any) => {
        return {
          schedule: ctx.fvSchedule,
          name: ctx.contextcodelabel+' - '+ctx.fvtypelabel+' - '+ctx.duration+' (M)',
        };
      });

 

  
    let currentDate = elem.fvdate
   
    let newObj = {
      fvdate: elem.fvdate,
      finrvamount:elem.finrvamount,
      fvcontext0:elem.fvamount,
      fvcontext1: 110,
      fvcontext2: 0,
      fvcontext3: 0,
      fvcontext4: 0,
      fvcontext5: 0,
      fvcontext6: 0,
      fvcontext7: 0,
      fvcontext8: 0,
      
  
    };

   
 

      fvcontext[0]?.schedule.forEach((sched: any) => {
        if (
          String(sched?.fvdate) === currentDate &&
          !isNil(sched?.fvdate)
        ) {

          newObj.finrvamount = sched.finrvamount;
          newObj.fvcontext1 = sched.fvamount;
        }
      });

      fvcontext[1]?.schedule.forEach((sched: any) => {
        if (
          String(sched?.fvdate) === currentDate &&
          !isNil(sched?.fvdate)
        ) {

          newObj.finrvamount = sched.finrvamount;
          newObj.fvcontext2 = sched.fvamount;
        }
      });

      fvcontext[2]?.schedule.forEach((sched: any) => {
        if (
          String(sched?.fvdate) === currentDate &&
          !isNil(sched?.fvdate)
        ) {

          newObj.finrvamount = sched.finrvamount;
          newObj.fvcontext3 = sched.fvamount;
        }
      });

      fvcontext[3]?.schedule.forEach((sched: any) => {
        if (
          String(sched?.fvdate) === currentDate &&
          !isNil(sched?.fvdate)
        ) {

          newObj.finrvamount = sched.finrvamount;
          newObj.fvcontext4 = sched.fvamount;
        }
      });

      fvcontext[4]?.schedule.forEach((sched: any) => {
        if (
          String(sched?.fvdate) === currentDate &&
          !isNil(sched?.fvdate)
        ) {

          newObj.finrvamount = sched.finrvamount;
          newObj.fvcontext5 = sched.fvamount;
        }
      });

      fvcontext[5]?.schedule.forEach((sched: any) => {
        if (
          String(sched?.fvdate) === currentDate &&
          !isNil(sched?.fvdate)
        ) {

          newObj.finrvamount = sched.finrvamount;
          newObj.fvcontext6 = sched.fvamount;
        }
      });
      fvcontext[6]?.schedule.forEach((sched: any) => {
        if (
          String(sched?.fvdate) === currentDate &&
          !isNil(sched?.fvdate)
        ) {

          newObj.finrvamount = sched.finrvamount;
          newObj.fvcontext7 = sched.fvamount;
        }
      });

      fvcontext[7]?.schedule.forEach((sched: any) => {
        if (
          String(sched?.fvdate) === currentDate &&
          !isNil(sched?.fvdate)
        ) {

          newObj.finrvamount = sched.finrvamount;
          newObj.fvcontext8 = sched.fvamount;
        }
      });
     
       
    return {
     
      fvdate:newObj.fvdate,
      finrvamount:newObj.finrvamount,
      fvcontext0name: firstContext?.contextcodelabel,
      fvcontext0: newObj.fvcontext0,
      fvcontext1name: fvcontext[0]?.name,
      fvcontext1: newObj.fvcontext1,
      fvcontext2name: fvcontext[1]?.name,
      fvcontext2: newObj.fvcontext2,
      fvcontext3name: fvcontext[2]?.name,
      fvcontext3: newObj.fvcontext3,
      fvcontext4name: fvcontext[3]?.name,
      fvcontext4: newObj.fvcontext4,
      fvcontext5name: fvcontext[4]?.name,
      fvcontext5: newObj.fvcontext5,
      fvcontext6name: fvcontext[5]?.name,
      fvcontext6: newObj.fvcontext6,
      fvcontext7name: fvcontext[6]?.name,
      fvcontext7: newObj.fvcontext7,
      fvcontext8name: fvcontext[7]?.name,
      fvcontext8: newObj.fvcontext8,

    };
  });




  const config = {
    data: data!
      .map((irv: any) => ({
        fvdate: irv.fvdate,
        irvtype: 'Fin. Outstanding',
        amount: Number(irv.finrvamount?.toFixed(0)),
      }))
      .concat(
        data.map((irv: any) => ({
          fvdate: irv.fvdate,
          irvtype: irv.fvcontext0name,//'fvcontext0',
          amount: Number(irv.fvcontext0?.toFixed(0)),
        }))
      ).concat(
        data[0]?.fvcontext1name===undefined?[]:data.map((irv: any) => ({
          fvdate: irv.fvdate,
          irvtype: irv.fvcontext1name,
          amount: Number(irv.fvcontext1?.toFixed(0)),
        }))
      ).concat(
        data[0]?.fvcontext2name===undefined?[]:data.map((irv: any) => ({
          fvdate: irv.fvdate,
          irvtype: irv.fvcontext2name,
          amount: Number(irv.fvcontext2?.toFixed(0)),
        }))
        .concat(
          data[0]?.fvcontext3name===undefined?[]:data.map((irv: any) => ({
            fvdate: irv.fvdate,
            irvtype: irv.fvcontext3name,
            amount: Number(irv.fvcontext3?.toFixed(0)),
          }))
        )
      ).concat(
        data[0]?.fvcontext4name===undefined?[]:data.map((irv: any) => ({
          fvdate: irv.fvdate,
          irvtype: irv.fvcontext4name,
          amount: Number(irv.fvcontext4?.toFixed(0)),
        }))
      ).concat(
        data[0]?.fvcontext5name===undefined?[]:data.map((irv: any) => ({
          fvdate: irv.fvdate,
          irvtype: irv.fvcontext5name,
          amount: Number(irv.fvcontext5?.toFixed(0)),
        }))
      ).concat(
        data[0]?.fvcontext6name===undefined?[]:data.map((irv: any) => ({
          fvdate: irv.fvdate,
          irvtype: irv.fvcontext6name,
          amount: Number(irv.fvcontext6?.toFixed(0)),
        }))
      ).concat(
        data[0]?.fvcontext7name===undefined?[]:data.map((irv: any) => ({
          fvdate: irv.fvdate,
          irvtype: irv.fvcontext7name,
          amount: Number(irv.fvcontext7?.toFixed(0)),
        }))
      ),
    xField: 'fvdate',
    yField: 'amount',
    seriesField: 'irvtype',
    xAxis: {
      type: 'time',
    },
    yAxis: {
      label: {
        formatter: (v: any) => toCurrency(v, localStorage.getItem('currcode') ?? ''),
      },
    },
  };
  const COLUMNS: DataGridColDef<any>[] = [
    {
      comcode: 'fvdate',
      dataIndex: 'fvdate',
      fixed: 'left',
      width: 80,
    },

    {
      align: 'right',
      title: 'finrvamount',
      dataIndex: 'finrvamount',
      render: (value, record: any) =>
      
            toCurrency(value, currcode ?? localStorage.getItem('currcode') ?? ''),
      
      width: 100,
    },


    {
      align: 'right',
      title: `${data[0]?.fvcontext0name}`,
      dataIndex: 'fvcontext0',
      render: (value, record: any) =>
      
            toCurrency(value, currcode ?? localStorage.getItem('currcode') ?? ''),
      
      width: 100,
    },



   {
      align: 'right',
      title: `${data[0]?.fvcontext1name}`,
      dataIndex: 'fvcontext1',
      render: (value, record: any) =>
      
            toCurrency(value, currcode ?? localStorage.getItem('currcode') ?? ''),
      
      width: 100,
    },
    {
      align: 'right',
      title: `${data[0]?.fvcontext2name}`,
      dataIndex: 'fvcontext2',
      render: (value, record: any) =>
      
            toCurrency(value, currcode ?? localStorage.getItem('currcode') ?? ''),
      
      width: 100,
    },
    {
      align: 'right',
      title: `${data[0]?.fvcontext3name}`,
      dataIndex: 'fvcontext3',
      render: (value, record: any) =>
      
            toCurrency(value, currcode ?? localStorage.getItem('currcode') ?? ''),
      
      width: 100,
    },
    {
      align: 'right',
      title: `${data[0]?.fvcontext4name}`,
      dataIndex: 'fvcontext4',
      render: (value, record: any) =>
      
            toCurrency(value, currcode ?? localStorage.getItem('currcode') ?? ''),
      
      width: 100,
    },
    {
      align: 'right',
      title: `${data[0]?.fvcontext5name}`,
      dataIndex: 'fvcontext5',
      render: (value, record: any) =>
      
            toCurrency(value, currcode ?? localStorage.getItem('currcode') ?? ''),
      
      width: 100,
    },
    {
      align: 'right',
      title: `${data[0]?.fvcontext6name}`,
      dataIndex: 'fvcontext6',
      render: (value, record: any) =>
      
            toCurrency(value, currcode ?? localStorage.getItem('currcode') ?? ''),
      
      width: 100,
    },
    {
      align: 'right',
      title: `${data[0]?.fvcontext7name}`,
      dataIndex: 'fvcontext7',
      render: (value, record: any) =>
      
            toCurrency(value, currcode ?? localStorage.getItem('currcode') ?? ''),
      
      width: 100,
    },

  ];

  const filterColumns = () => {

    let filteredColumns = COLUMNS;
   
    if (data.every((el) => el.fvcontext0name === undefined)) {
      filteredColumns = filteredColumns.filter((e) => e.dataIndex !== 'fvcontext0');
    }
    if (data.every((el) => el.fvcontext1name === undefined)) {
      filteredColumns = filteredColumns.filter((e) => e.dataIndex !== 'fvcontext1');
    }
    if (data.every((el) => el.fvcontext2name === undefined)) {
      filteredColumns = filteredColumns.filter((e) => e.dataIndex !== 'fvcontext2');
    }
    if (data.every((el) => el.fvcontext3name === undefined)) {
      filteredColumns = filteredColumns.filter((e) => e.dataIndex !== 'fvcontext3');
    }
    if (data.every((el) => el.fvcontext4name === undefined)) {
      filteredColumns = filteredColumns.filter((e) => e.dataIndex !== 'fvcontext4');
    }
    if (data.every((el) => el.fvcontext5name === undefined)) {
      filteredColumns = filteredColumns.filter((e) => e.dataIndex !== 'fvcontext5');
    }
    if (data.every((el) => el.fvcontext6name === undefined)) {
      filteredColumns = filteredColumns.filter((e) => e.dataIndex !== 'fvcontext6');
    }
    if (data.every((el) => el.fvcontext7name === undefined)) {
      filteredColumns = filteredColumns.filter((e) => e.dataIndex !== 'fvcontext7');
    }
   
    return filteredColumns;
  };
  return (
    <DF.Provider pagcode="assetfvschedule">
      <Tabs defaultActiveKey="1" animated>
        <TabPane tab={<GetLabel label="Table" />} key="1">
          <DataGrid
            dataSource={data}
            columns={filterColumns()}
            rowKey={(record: any) => record.fvdate}
            scroll={{ x: 1000, y: 360 }}
            pagination={{ pageSize: 200 }}
          />
        </TabPane>
        <TabPane tab={<GetLabel label="Charts" />} key="2">
          {!isNil(data) && <Line {...config} />}
        </TabPane>
      </Tabs>
    </DF.Provider>
  );
};

export default AssetFVMergedScheduleTable;
